<template>
	<div class="modal fade" id="dataSelectModal" tabindex="-1" aria-labelledby="lofInfoLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header justify-content-start">
					<div>
						<h5 class="modal-title">Data for {{ type.replace('_', ' ') }}</h5>
						<small>All available data </small>
					</div>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div class="row">
						<h4>Available {{ type.replace('_', ' ') }}</h4>
						<div v-if="!loading" class="col-12" style="max-height: 349px;overflow: auto;">
							<table v-if="items.length > 0" class="table table-hover">
								<tbody>
									<tr v-for="(item, i) in items" :key="i">
										<td class="align-middle">{{ item.title || item.name }}</td>
										<td width="150">
											<div class="d-flex justify-content-end align-items-center">
												<button class="btn btn-primary btn-sm" @click="selectItem(item)">
													Select
												</button>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-else>
							loading
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
import juniperApi from '../../../../api/juniperApi'
export default {
	name: 'DataSelectModal',
	components: {},
	data() {
		return {
			loading: false,
			items: [],
		}
	},
	props: ['type'],
	mounted() {},
	watch: {
		type: function() {
			this.getData()
		},
	},
	created() {},
	methods: {
		async getData() {
			this.loading = true
			if (this.type == 'FAQS') {
				let params = {
					per_page: 10000,
					client_id: this.$route.params.id,
				}
				juniperApi
					.get('/faqs', { params })
					.then(({ data }) => {
						this.items = data.faq_data
						this.loading = false
					})
					.catch(error => {
						this.loading = false
						console.log(error)
					})
			}
			if (this.type == 'NEWS') {
				let params = {
					per_page: 10000,
					client_id: this.$route.params.id,
				}
				juniperApi
					.get('/news-notices', { params })
					.then(({ data }) => {
						this.items = data.post_data
						this.loading = false
					})
					.catch(error => {
						this.loading = false
						console.log(error)
					})
			}
			if (this.type == 'DEPARTMENTS') {
				let params = {
					per_page: 10000,
					client_id: this.$route.params.id,
				}
				juniperApi
					.get('/departments', { params })
					.then(({ data }) => {
						console.log(data)
						this.items = data
						this.loading = false
					})
					.catch(error => {
						this.loading = false
						console.log(error)
					})
			}
			if (this.type == 'EVENT_CATEGORIES') {
				let heyGovJurisdiction = await this.getHeyGovJurisdiction();
				axios
					.get(`https://api.heygov.com/${heyGovJurisdiction}/events/categories`, {})
					.then(({ data }) => {
						console.log(data)
						this.items = data
						this.loading = false
					})
					.catch(error => {
						this.loading = false
						console.log(error)
					})
			}
		},
		selectItem(item) {
			this.$emit('selectDataItem', item)
		},
		getHeyGovJurisdiction() {

			return new Promise((resolve, reject) => { 
				
				juniperApi
					.post('/options/' + this.$route.params.id)
					.then(({ data }) => {
						console.log(data)
						resolve(data.heygov_jurisdiction);
					})
					.catch(error => {
						this.loading = false
						console.log(error)
						reject(error)
					})
			})
		}
	},
	emits: ['selectItem'],
}
</script>
